import type { FC, ReactNode } from "react";

import styles from "./ReadOnlyBlock.module.scss";

export interface ReadOnlyBlockProps {
  label: string;
  value: ReactNode;
  ctaContent?: ReactNode;
  dataTestId?: string;
}

export const ReadOnlyBlock: FC<ReadOnlyBlockProps> = ({ label, value, ctaContent, dataTestId }) => (
  <div aria-label={label} className={styles.wrapper} {...(dataTestId && { "data-testid": dataTestId })}>
    <div className={styles.textContent}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
    </div>
    {ctaContent && <div className={styles.ctaContent}>{ctaContent}</div>}
  </div>
);
